import { render, staticRenderFns } from "./AlternativeCommercialProductsList.vue?vue&type=template&id=3aeff044&"
import script from "./AlternativeCommercialProductsList.vue?vue&type=script&lang=js&"
export * from "./AlternativeCommercialProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports